<template>
  <LsModal :title="title" track-id="cancel_subscription_modal_step_three">
    <template #body>
      <article
        v-for="message in messages"
        :key="message.label"
        class="message"
        :class="message.class"
      >
        <div class="message-body cancel-subscription-modal-step-three--message">
          <span>{{ message.label }}</span>
          <p>{{ message.copy }}</p>
        </div>
      </article>
    </template>
    <template #footer>
      <LsButton
        text="ok"
        track-id="cancel_subscription_modal_step_three-ok"
        test-id="ok"
        @click="navOut('services')"
      />
    </template>
  </LsModal>
</template>

<script>
import { LsButton, LsModal } from '@/components/common';
import VueTypes from 'vue-types';

export default {
  name: 'CancelSubscriptionModalStepThree',
  components: {
    LsButton,
    LsModal,
  },
  props: {
    title: VueTypes.string.isRequired,
    messages: VueTypes.arrayOf({
      label: VueTypes.string.isRequired,
      copy: VueTypes.string.isRequired,
      class: VueTypes.string.isRequired,
    }).isRequired,
  },
  methods: {
    navOut(name) {
      this.$router.push({
        name,
      });

      this.$parent.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.cancel-subscription-modal-step-three--message {
  span {
    font-weight: bold;
    font-size: $size-4;
  }

  p {
    white-space: pre-line;
  }
}
.themed-app {
  .cancel-subscription-modal-step-three--message {
    span {
      font-size: $theme-txt-body-lg;
    }
  }
}
</style>
